function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#E68F1A;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#E68F1A;stroke-width:7;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2-2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22.9,22.9V11.5c0-4.2,3.4-7.7,7.7-7.7h30.7c4.2,0,7.7,3.5,7.7,7.7v25.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M68.9,59.2v21c0,4.2-3.4,7.7-7.7,7.7H30.6c-4.2,0-7.7-3.4-7.7-7.7V44"
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 22.9,
  y1: 15.2,
  x2: 68.9,
  y2: 15.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 22.9,
  y1: 76.4,
  x2: 68.9,
  y2: 76.4
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "53.6,38.1 53.6,57.2 53.6,66.9 63.1,57.2 88,57.2 88,38.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st1",
  points: "38.2,24.9 38.2,44 38.2,53.6 28.7,44 3.8,44 3.8,24.9  "
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 61.2,
  y1: 47.7,
  x2: 65,
  y2: 47.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 68.9,
  y1: 47.7,
  x2: 72.7,
  y2: 47.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 76.4,
  y1: 47.7,
  x2: 80.3,
  y2: 47.7
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 11.5,
  y1: 34.5,
  x2: 15.2,
  y2: 34.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 19.1,
  y1: 34.5,
  x2: 22.9,
  y2: 34.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 26.8,
  y1: 34.5,
  x2: 30.6,
  y2: 34.5
})));

var SvgSocialOrange = function SvgSocialOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2_00000065054324905308131070000001122042174494824616_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91.8 91.8",
    style: {
      enableBackground: "new 0 0 91.8 91.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social_orange.cedc04a5.svg";
export { ForwardRef as ReactComponent };